import ga from '../utils/ga'

// https://github.com/envato/marketplace/blob/master/app/assets/javascripts/market/shared/google_analytics/_promo.js.coffee
export const reportHeaderBannerClick = payload => {
  ga('ec:addPromo', payload)
  ga('ec:setAction', 'promo_click')
  ga('send', 'event', 'Internal Promotions', 'click', {
    label: payload.name
  })
}



// WEBPACK FOOTER //
// ./common/analytics/bannerAnalytics.js